import React, { useState } from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { PieChartOutlined, ShopOutlined, MoneyCollectOutlined, UserOutlined, InfoCircleOutlined, MailOutlined, FileDoneOutlined } from '@ant-design/icons';
import { Breadcrumb, Layout, Menu, Avatar, Dropdown, message, theme } from 'antd';
import { useLocation } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import MerchantListPage from './pages/merchant/MerchantListPage';
import MerchantManagementPage from './pages/merchant/MerchantManagementPage';
import TransactionListPage from './pages/transaction/TransactionListPage';
import TransactionOverviewPage from './pages/transaction/TransactionOverviewPage';
import NewMerchantPage from './pages/merchant/NewMerchantPage';
import TransactionDetailPage from './pages/transaction/TransactionDetailPage';
import Login from './pages/login/Login';
import authStore from './stores/AuthStore';
import tokenStore from './stores/TokenStore';
import FeedbackPage from './pages/feedback/FeedbackPage';
import LoginCardStyle from './pages/login/LoginCardStyle';
import MerchantDetailPage from './pages/merchant/MerchantDetailPage';
import SettlementList from './pages/settlement/SettlementListPage';
import SettlementDetail from './pages/settlement/SettlementDetail';
import SettlementPendingList from './pages/settlement/SettlementPendingListPage';
import QRCodeGenerator from './pages/merchant/QRCodeGenerator';

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

function getItem(label, key, icon, children, path) {
  return {
    key,
    icon,
    children,
    label,
    path,
  };
}

const items = [
  getItem('Home', '1', <PieChartOutlined />, undefined, '/'),
  getItem('Merchant', 'sub1', <ShopOutlined />, [
    getItem('Merchant List', '3', undefined, undefined, '/merchants/list'),
    // getItem('Merchant Management', '4', undefined, undefined, '/merchants/management'),
    getItem('New Merchant', '5', undefined, undefined, '/merchants/new-merchant'),
  ], '/merchants'),
  getItem('Transaction', 'sub2', <MoneyCollectOutlined />, [
    getItem('Overview', '6', undefined, undefined, '/transactions/overview'),
    getItem('Transaction List', '7', undefined, undefined, '/transactions/list'),
    // getItem('Transaction Detail', '8', undefined, undefined, '/transactions/detail'),
  ], '/transactions'),
  getItem('Settlement', 'settlement', <FileDoneOutlined />, [
    getItem('To Be Settled', 'to-be-settled', undefined, undefined, '/settlement/to-be-settled'),
    // getItem('Settled', 'settled', undefined, undefined, '/file-group'),
    getItem('All Settlements', 'settlement-list', undefined, undefined, '/settlement/list'),
    // getItem('Query', 'all', undefined, undefined, '/file-group'),
  ], '/settlement'),
  getItem("Feedback", "10", <MailOutlined />, undefined, "/feedback"),
  getItem('About', '9', <InfoCircleOutlined />, undefined, '/about'),
];

const Home = () => HomePage();
const Merchants = () => <div>Merchants Page</div>;
const MerchantList = () => MerchantListPage();
const MerchantManagement = () => MerchantManagementPage();
const NewMerchant = () => NewMerchantPage();
const Transactions = () => <div>Transactions Page</div>;
const TransactionsOverview = () => TransactionOverviewPage();
const TransactionsList = () => TransactionListPage();
const TransactionDetail = () => TransactionDetailPage();
const FilesGroup = () => <div>Files Group Page</div>;
const Feedback = () => FeedbackPage();
const About = () => <div>v1.0.0</div>;
const LoginPage = () => Login();
const LoginCardStylePage = () => LoginCardStyle();
const MerchantDetail = () => MerchantDetailPage();
const Settlements = () => SettlementList();
const SettlementDetailPage = () => SettlementDetail();
const ToBeSettled = () => SettlementPendingList();
const PaymentQrCode = () => QRCodeGenerator();

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter(i => i);

  const handleLogout = () => {
    authStore.logout();
    tokenStore.removeToken();
    window.location.href = '/login';
    message.success('Logged out successfully');
  };

  const menuItems = [
    {
      key: '1',
      label: <Link to="/settings">Settings</Link>,
    },
    {
      key: '2',
      label: <span onClick={handleLogout}>Logout</span>,
    },
  ];

  const menu = <Menu items={menuItems} />;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!authStore.isLoggedIn ? (
        <Routes>
          <Route path="/login" element={<LoginCardStylePage />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      ) : (
        <>
          <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
            <div className="demo-logo-vertical" />
            <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
              {items.map(item => {
                if (item.children) {
                  return (
                    <SubMenu key={item.key} icon={item.icon} title={item.label}>
                      {item.children.map(child => (
                        <Menu.Item key={child.key}>
                          <Link to={child.path}>{child.label}</Link>
                        </Menu.Item>
                      ))}
                    </SubMenu>
                  );
                }
                return (
                  <Menu.Item key={item.key} icon={item.icon}>
                    <Link to={item.path}>{item.label}</Link>
                  </Menu.Item>
                );
              })}
            </Menu>
          </Sider>
          <Layout>
            <Header style={{ padding: '0 16px', background: colorBgContainer, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div />
              <Dropdown overlay={menu} trigger={['click']}>
                <Avatar style={{ cursor: 'pointer' }} icon={<UserOutlined />} />
              </Dropdown>
            </Header>
            <Content style={{ margin: '0 16px' }}>
              <Breadcrumb style={{ margin: '16px 0' }}>
                {pathSnippets.map((snippet, index) => {
                  const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
                  const item = items.find(item => item.path === url);
                  return (
                    <Breadcrumb.Item key={url}>
                      {item ? <Link to={url}>{item.label}</Link> : snippet}
                    </Breadcrumb.Item>
                  );
                })}
              </Breadcrumb>
              <div style={{ padding: 24, minHeight: 360, background: colorBgContainer, borderRadius: borderRadiusLG }}>
                <Routes>
                  <Route exact path="/" element={<Home />} />
                  <Route path="/merchants" element={<MerchantList />} />
                  <Route path="/merchants/list" element={<MerchantList />} />
                  <Route path="/merchants/management" element={<MerchantManagement />} />
                  <Route path="/merchants/new-merchant" element={<NewMerchant />} />
                  <Route path="/merchants/detail/:id" element={<MerchantDetail />} />
                  <Route path="/merchants/payment-qrcode" element={<PaymentQrCode />} />
                  <Route path="/transactions" element={<TransactionsList />} />
                  <Route path="/transactions/overview" element={<TransactionsOverview />} />
                  <Route path="/transactions/list" element={<TransactionsList />} />
                  <Route path="/transactions/detail/:id" element={<TransactionDetail />} />
                  <Route path="/settlement" element={<Settlements />} />
                  <Route path="/settlement/to-be-settled" element={<ToBeSettled />} />
                  <Route path="/settlement/list" element={<SettlementList />} />
                  <Route path="/settlement/detail/:id" element={<SettlementDetailPage />} />                  
                  <Route path="/feedback" element={<Feedback />} />
                  <Route path="/about" element={<About />} /> 
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </div>
            </Content>
            <Footer style={{ textAlign: 'center' }}>Tomato Pay ©{new Date().getFullYear()}</Footer>
          </Layout>
        </>)}
    </Layout>
  );
};

export default App;
